module.exports = __webpack_public_path__ + "img/star.5b9e58b6.svg";